import { render, staticRenderFns } from "./App.vue?vue&type=template&id=e4827750&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "./App.vue?vue&type=style&index=0&id=e4827750&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4827750",
  null
  
)

export default component.exports